<template>
  <div>
    <h2>{{ $t('recherche.list.mainTitle') }}</h2>

    <b-alert v-model="hasError" variant="danger">
      {{ errorMessage }}
    </b-alert>

    <dx-data-grid
      id="gridContainerRecherche"
      :data-source="items"
      :allow-column-reordering="false"
      :allow-column-resizing="true"
      :column-min-width="50"
      columnResizingMode="widget"
      :show-borders="true"
      :showColumnLines="true"
      :showRowLines="true"
      key-expr="field_001"
      :no-data-text="$t('general.noEntries')"
      :column-auto-width="true"
      :word-wrap-enabled="true"
      :hover-state-enabled="true"
      :focused-row-enabled="true"
      @row-click="onRowSelected"
      @toolbar-preparing="onToolbarPreparing"
    > <!-- :onOptionChanged="getList" -->

      <dx-scrolling mode="virtual"/>

      <dx-search-panel
        :visible="true"
        :width="320"
        placeholder="Search..."
      />

      <dx-column
        data-field="field_001"
        :caption="$t('recherche.list.id')"
        :fixed="true"
      />
      <dx-column
        data-field="datum"
        :caption="$t('recherche.list.displaydate')"
        :calculate-cell-value="dateCellValue"
      />
      <dx-column
        data-field="bezeichnung"
        :caption="$t('recherche.list.eventname')"
        :allow-filtering="true"
      />
      <dx-column
        data-field="cRMMitarbeiter.vorname"
        :caption="$t('recherche.list.creatorFirstname')"
        :allow-filtering="true"
      />
      <dx-column
        data-field="cRMMitarbeiter.nachname"
        :caption="$t('recherche.list.creatorLastname')"
        :allow-filtering="true"
      />
      <template #customizeTemplateButtons>
        <dx-button
          text="Ambassadors"
          type="normal"
          styling-mode="contained"
          @click="$router.push('ambassadors')"
        />
      </template>
      <dx-summary>
        <dx-total-item
          column="field_001"
          summary-type="count"
        />
      </dx-summary>
    </dx-data-grid>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSearchPanel,
    DxSummary,
    DxTotalItem
  } from 'devextreme-vue/data-grid'
  import DxButton from 'devextreme-vue/button'
  import moment from 'moment'

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxScrolling,
      DxSearchPanel,
      DxSummary,
      DxTotalItem,
      DxButton
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        isBusy: false
      }
    },
    created () {
      this.onGetRechercheList()
      this.getBasicValues('basicValues/GET_FACULTY_UNIVERSITY_TYPES', this.facultyUniversityTypes)
      this.getBasicValues('basicValues/GET_UNIVERSITY_TYPES', this.universityTypes)
      this.getBasicValues('basicValues/GET_BRANCHE_TYPES', this.brancheTypes)
      this.getBasicValues('basicValues/GET_STARTUPHASE_TYPES', this.startupPhaseTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_CASEQUALITY_TYPES', this.casequalityTypes)
      this.getBasicValues('basicValues/GET_RECHTSFORM_TYPES', this.rechtsformTypes)
      this.getBasicValues('basicValues/GET_LANGUAGES_TYPES', this.languagesTypes)
      this.getBasicValues('basicValues/GET_EDUCATION_TYPES', this.educationTypes)
      this.getBasicValues('basicValues/GET_CANTON_TYPES', this.cantonTypes)
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_PRIOVLABXMAS_TYPES', this.priovlabxmasTypes)
      this.getBasicValues('basicValues/GET_PROFILCATEGORY_TYPES', this.profilcategoryTypes)
      this.getBasicValues('basicValues/GET_VKCASESTATUS_TYPES', this.vkCaseStatusTypes)
      this.getBasicValues('basicValues/GET_INVESTMENT_STAGES', this.investmentStages)
      this.getBasicValues('basicValues/GET_ROLES', this.roles)
    },
    methods: {
      async onGetRechercheList (data) {
        this.hasError = false
        this.isBusy = true
        this.$Progress.start()

        try {
          const { errors } = await this.$store.dispatch('recherche/GET_RECHERCHE_LISTS')
          if (errors) throw errors
          this.isBusy = false
          this.$Progress.finish()
        } catch (err) {
          this.isBusy = false
          this.hasError = true
          this.$Progress.fail()
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      async getBasicValues (storePath, storeValue) {
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
          }
        }
      },
      dateCellValue (rowData) {
        return moment(rowData.datum).format('DD.MM.YYYY')
      },
      async onRowSelected (e) {
        const field_001 = e.data.field_001 /* eslint-disable-line */

        await this.$router.push({
          name: 'recherche-detail',
          params: { id: field_001 }
        })
      },
      onToolbarPreparing (e) {
        e.toolbarOptions.items.unshift({
          location: 'after',
          template: 'customizeTemplateButtons'
        })
      }
    },
    computed: {
      ...mapGetters({
        items: 'recherche/RECHERCHELISTS',
        facultyUniversityTypes: 'basicValues/FACULTY_UNIVERSITY_TYPES',
        universityTypes: 'basicValues/UNIVERSITY_TYPES',
        brancheTypes: 'basicValues/BRANCHE_TYPES',
        startupPhaseTypes: 'basicValues/STARTUPHASE_TYPES',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        casequalityTypes: 'basicValues/CASEQUALITY_TYPES',
        rechtsformTypes: 'basicValues/RECHTSFORM_TYPES',
        languagesTypes: 'basicValues/LANGUAGES_TYPES',
        educationTypes: 'basicValues/EDUCATION_TYPES',
        cantonTypes: 'basicValues/CANTON_TYPES',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        priovlabxmasTypes: 'basicValues/PRIOVLABXMAS_TYPES',
        profilcategoryTypes: 'basicValues/PROFILCATEGORY_TYPES',
        vkCaseStatusTypes: 'basicValues/VKCASESTATUS_TYPES',
        investmentStages: 'basicValues/INVESTMENT_STAGES',
        roles: 'basicValues/ROLES'
      })
    }
  }
</script>
<style>
#gridContainerRecherche {
    height: 78vh;
    margin-bottom: 0;
}

.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row) > td:not(.dx-focused) {
    cursor: pointer;
}
</style>
